"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePointerPosition = void 0;
const getActivePointerPosition = ({ interactions }) => {
    return interactions.pointer.pinned?.position ?? interactions.pointer.current.position;
};
exports.getActivePointerPosition = getActivePointerPosition;
//# sourceMappingURL=get_active_pointer_position.js.map